package nl.volleyplanner.api.client.planner

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import nl.volleyplanner.api.InviteOrganisationUserRequest
import nl.volleyplanner.api.InviteOrganisationUserResponse
import nl.volleyplanner.api.InviteRefreshRequest
import nl.volleyplanner.api.OrganisationUser
import nl.volleyplanner.api.RemoveOrganisationUserRequest
import nl.volleyplanner.api.User

class OrganisationAdminEndpoint(val httpClient: HttpClient, prefix: String) {
    private val base = "$prefix/admin"

    suspend fun listUsers() : List<OrganisationUser> {
        return httpClient.get("$base/users/list").body()
    }

    suspend fun inviteUser(request: InviteOrganisationUserRequest): InviteOrganisationUserResponse =
        httpClient.post("$base/users/invite") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun refreshUserInvite(user: OrganisationUser) = httpClient.post("$base/users/refresh-user-invite") {
        contentType(ContentType.Application.Json)
        setBody(InviteRefreshRequest(user.email))
    }.body<InviteOrganisationUserResponse>()

    suspend fun removeUser(user: OrganisationUser) = httpClient.post("$base/users/remove") {
        contentType(ContentType.Application.Json)
        setBody(RemoveOrganisationUserRequest(userEmail = user.email))
    }
}